<template>
  <div>
    <b-skeleton-wrapper :loading="loading">
      <template #loading>
        <b-row class="margin-0">
          <b-col
            cols="12"
            class="padding-0 flex-center flex-direction-column margin-bottom-16"
          >
            <b-skeleton
              class="border-radius-40 margin-bottom-16 width-132 height-132"
              width="100%"
            ></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="40%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="30%"></b-skeleton>
          </b-col>
          <b-col cols="12" class="padding-0 margin-bottom-16">
            <b-skeleton class="margin-bottom-8" width="20%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="50%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="60%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="70%"></b-skeleton>
          </b-col>
          <b-col cols="12" class="padding-0 margin-bottom-16">
            <b-skeleton class="margin-bottom-8" width="20%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="50%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="60%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="70%"></b-skeleton>
          </b-col>
          <b-col cols="12" class="padding-0 margin-bottom-16">
            <b-skeleton class="margin-bottom-8" width="20%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="50%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="60%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="70%"></b-skeleton>
          </b-col>
          <b-col cols="12" class="padding-0 margin-bottom-16">
            <b-skeleton class="margin-bottom-8" width="20%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="50%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="60%"></b-skeleton>
            <b-skeleton class="margin-bottom-8" width="70%"></b-skeleton>
          </b-col>
        </b-row>
      </template>
      <slot name="default"></slot>
    </b-skeleton-wrapper>
  </div>
</template>

<script>
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
